export const recaptchaConfig = {
    site_key: '6LfcM50qAAAAAC4XaGlWZ41lzltvJaUdyRw1DhYI',
}
